import { Check } from "lucide-react";
import { cn } from "../lib/utils";

/**
 * Named, numbered wizard progress.
 *
 * A bare progress bar tells you how far along you are but not what's left, and
 * gives you no way back. Completed steps here are clickable, so a mistake three
 * steps ago costs one click rather than a restart.
 */
export default function WizardSteps({ steps, current, onStepClick }) {
  return (
    <ol className="flex w-full items-center gap-1">
      {steps.map((step, i) => {
        const done = i < current;
        const active = i === current;
        const clickable = done && onStepClick;

        return (
          <li key={step.key} className="flex flex-1 items-center gap-1">
            <button
              type="button"
              disabled={!clickable}
              onClick={() => clickable && onStepClick(i)}
              className={cn(
                "flex flex-1 items-center gap-2 rounded-md px-2 py-1.5 text-left transition-colors",
                clickable && "hover:bg-muted/60",
                !clickable && "cursor-default"
              )}
            >
              <span
                className={cn(
                  "flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors",
                  done && "bg-secondary text-secondary-foreground",
                  active && "bg-primary text-primary-foreground",
                  !done && !active && "border border-border bg-card text-muted-foreground"
                )}
              >
                {done ? <Check className="h-3.5 w-3.5" strokeWidth={3} /> : i + 1}
              </span>
              <span
                className={cn(
                  "hidden truncate text-sm sm:block",
                  active ? "font-medium text-foreground" : "text-muted-foreground"
                )}
              >
                {step.label}
              </span>
            </button>

            {i < steps.length - 1 && (
              <span
                aria-hidden="true"
                className={cn("h-px w-4 shrink-0", done ? "bg-secondary" : "bg-border")}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
